module.exports = __webpack_public_path__ + "asset/img/load-shop-list-failed.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/load-shop-list-failed.png
// module id = 1757
// module chunks = 38